export enum InvoiceMappingField {
    Id = "id",
    Number = "number",
}
